module.exports = __webpack_public_path__ + "61c178066bdffca1a7d1730d9df40491.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ic_linkedin.svg
// module id = gwPP
// module chunks = 5